import React, { Component } from 'react';
import { graphql } from '@apollo/client/react/hoc';
import {gql} from '@apollo/client';

export default function executiveWithData(WrappedComponent, options = {}) {
	const HOC = class extends Component {
		constructor(props) {
			super(props);
			this.wrapped = graphql(gql `query exectuivePageQuery {
			  executivePages {
			    backgroundHeader
			    backgroundDescription
			    backgroundImage {
			      title
			      description
			      url
			    }
			    executive {
			      name
			      title
			      picture {
			        title
			        description
			        url
			      }
			    }
			  }
			  feedbackComponents {
			    feedbackHeader
			    feedbackDescription
			    feedbackCtAtext
			    feedbackImage {
			      title
			      description
			      url
			    }
			  }
			  headerFooterComponents {
			    footerHeader
			    footerBody
			    copyrightHolder
			    primaryNavigationLinks{
			      route
			      text
			    }
				seasonalPrimaryNavigationLinks{
				  route
				  text
				}
			    footerLinks{
			      route
			      text
			    }
			    seasonalFooterLinks{
			      route
			      text
			    }
			    secondaryFooterLinks {
			      route
			      text
			    }
			    footerLogo {
			      title
			      description
			      url
			    }
			  }
			  exploreComponents {
				    isNotDisplayed
				    exploreTitle
				    exploreTile {
				    backgroundImage {
					        title
					        description
					        url
					      }
				      route
				      title
				      ctaText
				  }
			  }
			  globalSites{feedback {
						 feedbackHeader
						 feedbackDescription
						 feedbackCtAtext
					   feedbackImage {
						 title
						 description
						 url
						}
					}
				  mainNavigation {
						 footerHeader
						 footerBody
						 copyrightHolder
						 primaryNavigationLinks{
							 route
							 text
						 }
						 seasonalPrimaryNavigationLinks{
						  route
						  text
						 }
						 footerLinks{
						   route
						   text
						 }
					     seasonalFooterLinks{
					      route
					      text
					     }
						 secondaryFooterLinks {
						   route
						   text
						 }
						 footerLogo {
						   title
						   description
						   url
						 }
				   }
				   cubsLogo{
		              title
		              url
		            }
			  }
}
	  `, { name: 'executivePageQuery' })(WrappedComponent);
		}

		render() {
			const Wrapped = this.wrapped;
			return <Wrapped {...this.props}/>;

		}
	};

	return HOC;
}